export const isNavigationDropdownOpen = state => state.navigation.dropdownOpen



/** WEBPACK FOOTER **
 ** ./src/selectors/navigation/navigation-selectors.js
 **/